import { useEffect, useRef } from 'react';

/**
 * A hook to store previous data
 * @param value Generic data
 * @property {object} options
 * @property {boolean} options.isImmediate Condition to add the value as default
 * @see https://usehooks.com/usePrevious/
 */
export function usePrevious<T>(value: T, { isImmediate }: {
  isImmediate?: boolean;
} = {}): T {
  const ref: any = useRef<T | undefined>(isImmediate ? value : undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
